import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Headline } from '@folio/stripes/components';
import css from './TableStates.css';
/**
 * CZNA-538 — the third state these lists never had.
 *
 * Until now a failed query fell through to the same branch as a successful empty one
 * ("nothing matching your criteria"), because the render only asked `items.length === 0`.
 * That is the worst of the three confusions in this ticket: it tells the user their
 * filter is wrong when in fact nothing was asked of the server, or the server refused.
 */
var TableErrorState = function (_a) {
    var error = _a.error, onRetry = _a.onRetry, _b = _a.testId, testId = _b === void 0 ? 'table-error-state' : _b;
    var detail = error instanceof Error ? error.message : String(error !== null && error !== void 0 ? error : '');
    return (React.createElement("div", { className: css.error, "data-testid": testId },
        React.createElement("div", { role: "alert" },
            React.createElement(Headline, { size: "medium", margin: "none" },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.tableStates.error" })),
            React.createElement("p", { className: css.errorDetail },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.tableStates.errorHint" }))),
        onRetry && (React.createElement(Button, { onClick: onRetry },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.tableStates.retry" }))),
        detail && (React.createElement("details", { className: css.errorDetails, "data-testid": "".concat(testId, "-details") },
            React.createElement("summary", { className: css.errorDetailsToggle },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.tableStates.errorDetailsToggle" })),
            React.createElement("p", { className: css.errorDetail, "data-testid": "".concat(testId, "-detail") }, detail)))));
};
export default TableErrorState;
